import { useDownloadableContents } from "@/features/downloadable-content";
import { WorksheetCard } from "../ui/WorksheetCard";

/**
 * SupportWorksheet - 워크지 탭 콘텐츠 컴포넌트
 * 다운로드 가능한 콘텐츠 API에서 데이터를 로드합니다
 */
export const SupportWorksheet = () => {
  const { data: allContents = [], isLoading } = useDownloadableContents(true);

  // 타입이 'worksheet'인 콘텐츠만 필터링
  const worksheets = allContents.filter(
    (content) => content.content_type === "worksheet"
  );

  return (
    <div className="w-full flex flex-col gap-12 md:gap-14">
      {/* Worksheet Header */}
      <div className="flex flex-col gap-6">
        <p className="text-lg text-gray-400">고객지원</p>
        <h1 className="text-3xl md:text-4xl font-normal text-black leading-tight">
          워크지 다운받기
        </h1>
        <p className="text-base md:text-lg text-black leading-7">
          유아부터 초등 입문까지 단계별로 학습할 수 있는 워크지를 제공합니다.
          <br></br>
          개인 회원은 일부 워크지를 무료로 이용할 수 있습니다.<br></br>
          언제든 출력해 학습을 시작해 보세요.
        </p>
      </div>

      {/* Worksheets Grid */}
      <div className="flex flex-col gap-14">
        {/* Loading State */}
        {isLoading && (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          </div>
        )}

        {!isLoading && worksheets.length > 0 && (
          <div className="flex flex-col gap-10 md:gap-14">
            <div className="overflow-x-auto">
              <div className="flex gap-5 min-w-min">
                {worksheets.slice(0, 4).map((worksheet) => (
                  <WorksheetCard key={worksheet.id} worksheet={worksheet} />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* individual User Section - Free Worksheets */}
        {/* {!isLoading && worksheets.length > 0 && (
          <div className="flex flex-col gap-10 md:gap-14">
            <div className="flex flex-col gap-6">
              <p className="text-gray-400">개인 회원</p>
              <h2 className="text-2xl md:text-3xl font-normal text-black">
                무료 제공 워크지
              </h2>
              <p className="text-base md:text-lg text-black leading-7">
                개인 회원은 아래의 일부 워크지를 제한 없이 무료로 다운로드할 수
                있습니다.
              </p>
            </div>
            <div className="overflow-x-auto">
              <div className="flex gap-5 min-w-min">
                {worksheets.slice(0, 4).map((worksheet) => (
                  <WorksheetCard key={worksheet.id} worksheet={worksheet} />
                ))}
              </div>
            </div>
          </div>
        )} */}

        {/* Kindergarten Section - All Worksheets */}
        {/* {!isLoading && worksheets.length > 0 && (
          <div className="flex flex-col gap-10 md:gap-14">
            <div className="flex flex-col gap-6">
              <p className="text-gray-400">유치원 회원</p>
              <h2 className="text-2xl md:text-3xl font-normal text-black">
                전체 워크지 무료 제공
              </h2>
              <p className="text-base md:text-lg text-black leading-7">
                유치원 회원은 아래의 모든 워크지를 제한 없이 무료로 다운로드할
                수 있습니다.
              </p>
            </div>
            <div className="overflow-x-auto">
              <div className="flex gap-5 min-w-min">
                {worksheets.map((worksheet) => (
                  <WorksheetCard key={worksheet.id} worksheet={worksheet} />
                ))}
              </div>
            </div>
          </div>
        )} */}

        {/* Additional Section - All Worksheets */}
        {/* {!isLoading && worksheets.length > 0 && (
          <div className="flex flex-col gap-10 md:gap-14">
            <div className="flex flex-col gap-6">
              <p className="text-gray-400">기타 회원</p>
              <h2 className="text-2xl md:text-3xl font-normal text-black">
                전체 워크지 무료 제공
              </h2>
              <p className="text-base md:text-lg text-black leading-7">
                기타 회원은 아래의 모든 워크지를 제한 없이 무료로 다운로드할 수
                있습니다.
              </p>
            </div>
            <div className="overflow-x-auto">
              <div className="flex gap-5 min-w-min">
                {worksheets.map((worksheet) => (
                  <WorksheetCard key={worksheet.id} worksheet={worksheet} />
                ))}
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};
